import { render, staticRenderFns } from "./PacsTableCell.vue?vue&type=template&id=b017d60c"
import script from "./PacsTableCell.vue?vue&type=script&lang=js"
export * from "./PacsTableCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports